import { render, staticRenderFns } from "./AkbsContractForm.vue?vue&type=template&id=472a1270&scoped=true&"
import script from "./AkbsContractForm.vue?vue&type=script&lang=js&"
export * from "./AkbsContractForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./AkbsContractForm.vue?vue&type=style&index=1&id=472a1270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472a1270",
  null
  
)

export default component.exports